import { render, staticRenderFns } from "./SliceHeader.vue?vue&type=template&id=28152112&scoped=true"
import script from "./SliceHeader.vue?vue&type=script&lang=js"
export * from "./SliceHeader.vue?vue&type=script&lang=js"
import style0 from "./SliceHeader.vue?vue&type=style&index=0&id=28152112&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28152112",
  null
  
)

export default component.exports